import React from "react";
import MenuItems from "./MenuItems";

function Dropdown({ submenus, dropdown, depthLevel, autenticazione }) {
    depthLevel = depthLevel + 1;
    const dropdownClass = depthLevel > 1 ? "dropdown-submenu" : "";
    return(
        <ul className={`dropdownMenu ${dropdownClass} ${dropdown ? "show" : ""}`}>
      {submenus.map((submenu, index) => (
        <MenuItems items={submenu} key={index} depthLevel={depthLevel} autenticazione={autenticazione} />
      ))}
    </ul>
    )
}

export default Dropdown;